import axios from "axios";
import { bun_server } from "./baseUrl";

/*GET METHODE*/

export const get_geocode_address = (params) => async (dispatch) => {
  //type === auto_address
  //get_geocode_address
  /*
  body = {
    lat,
    long,
    uuid,
    child_uuid
  }
  */

  dispatch({
    type: "SET_LOADING_FORM",
    payload: "get_geocode_address",
  });
  const { lat, long, uuid, child_uuid } = params;
  try {
    dispatch({
      type: "set_value",
      payload: {
        key: "uuid_process",
        value: uuid,
      },
    });
    const res = await axios.get(
      `https://api.maptiler.com/geocoding/${long},${lat}.json?key=CVYOeJckfxqURN5wjKEB`,
    );
    const features = res?.data?.features;
    const value = features?.[0]?.place_name || "Tidak ada alamat terdekat";

    if (!child_uuid) {
      dispatch({
        type: "change_text",
        payload: {
          uuid: uuid,
          value: value,
        },
      });
    } else {
      dispatch({
        type: "change_child",
        payload: {
          uuid: uuid,
          value: value,
          child_uuid,
        },
      });
    }
    dispatch({
      type: "CLEAR_LOADING_FORM",
    });
  } catch (e) {
    if (!child_uuid) {
      dispatch({
        type: "change_text",
        payload: {
          uuid: uuid,
          value: "-",
        },
      });
    } else {
      dispatch({
        type: "change_child",
        payload: {
          uuid: uuid,
          value: "-",
          child_uuid,
        },
      });
    }
    dispatch({
      type: "CLEAR_LOADING_FORM",
    });
  }
};

export const get_geocode_address_poi = (params) => async (dispatch) => {
  /*
  type === auto_address_poi

  body={
  lat,
  long,
  uuid,
  child_uuid
  }
  */
  dispatch({
    type: "SET_LOADING_FORM",
    payload: "get_geocode_address_poi",
  });
  const { long, lat, uuid, child_uuid } = params;
  try {
    dispatch({
      type: "set_value",
      payload: {
        key: "uuid_process",
        value: uuid,
      },
    });
    const res = await axios.get(
      // `https://api.mapbox.com/geocoding/v5/mapbox.places/${long},${lat}.json?types=poi&access_token=pk.eyJ1IjoibWFwaWQiLCJhIjoiY2pqNWtnaW10MGNnMjNrcWg5MHQwY21nNiJ9.voWwMqU73TCDDua3mGCb8g`
      `${bun_server}/sini_v2/nearest_poi?long=${long}&lat=${lat}`,
    );

    let value = res.data?.properties?.NAMA || "Tidak ada gedung terdekat";

    if (!child_uuid) {
      dispatch({
        type: "change_text",
        payload: {
          uuid: uuid,
          value: value,
        },
      });
    } else {
      dispatch({
        type: "change_child",
        payload: {
          uuid: uuid,
          value: value,
          child_uuid,
        },
      });
    }
    dispatch({
      type: "CLEAR_LOADING_FORM",
    });
  } catch (error) {
    if (!child_uuid) {
      dispatch({
        type: "change_text",
        payload: {
          uuid: uuid,
          value: "-",
        },
      });
    } else {
      dispatch({
        type: "change_child",
        payload: {
          uuid: uuid,
          value: "-",
          child_uuid,
        },
      });
    }
    dispatch({
      type: "CLEAR_LOADING_FORM",
    });
  }
};

/*POST METHODE*/

/*NON POI*/

export const set_value_properties = (body) => {
  /*
  body: {
  key,
  value
  }
  */

  return {
    type: "set_value_properties",
    payload: body,
  };
};

//set_child_index_new
/*
body = { parent_uuid, child_uuid, level }
*/
export const set_child_index_new = (body) => (dispatch) => {
  dispatch({
    type: "set_child_index_new",
    payload: body,
  });
};

//one_step_back_child
/*
body = { level }
*/
export const one_step_back_child = () => (dispatch) => {
  dispatch({
    type: "one_step_back_child",
  });
};

export const get_location_list =
  ({ search_input, viewbox }) =>
  async (dispatch) => {
    try {
      const endpoint_api = `https://nominatim.mapid.io/search?format=jsonv2&addressdetails=1&limit=10&polygon_geojson=1&viewbox=${viewbox}&q=${search_input}`;
      const res = await axios.get(endpoint_api);

      /*
      [
  {
    "place_id": 2857335,
    "licence": "Data © OpenStreetMap contributors, ODbL 1.0. http://osm.org/copyright",
    "osm_type": "relation",
    "osm_id": 9686818,
    "lat": "-7.0110802",
    "lon": "109.39140368595727",
    "category": "boundary",
    "type": "administrative",
    "place_rank": 12,
    "importance": 0.24000999999999997,
    "addresstype": "county",
    "name": "Pemalang",
    "display_name": "Pemalang, Jawa Tengah, Jawa, Indonesia",
    "address": {
      "county": "Pemalang",
      "state": "Jawa Tengah",
      "ISO3166-2-lvl4": "ID-JT",
      "region": "Jawa",
      "ISO3166-2-lvl3": "ID-JW",
      "country": "Indonesia",
      "country_code": "id"
    },
    "boundingbox": ["-7.2488851", "-6.7733087", "109.1855868", "109.5991961"]
  },
  {
    "place_id": 3759557,
    "licence": "Data © OpenStreetMap contributors, ODbL 1.0. http://osm.org/copyright",
    "osm_type": "node",
    "osm_id": 10957525365,
    "lat": "-6.8903801",
    "lon": "109.3806311",
    "category": "place",
    "type": "town",
    "place_rank": 18,
    "importance": 0.16000999999999999,
    "addresstype": "town",
    "name": "Pemalang",
    "display_name": "Pemalang, Jawa Tengah, Jawa, 52312, Indonesia",
    "address": {
      "town": "Pemalang",
      "county": "Pemalang",
      "state": "Jawa Tengah",
      "ISO3166-2-lvl4": "ID-JT",
      "region": "Jawa",
      "ISO3166-2-lvl3": "ID-JW",
      "postcode": "52312",
      "country": "Indonesia",
      "country_code": "id"
    },
    "boundingbox": ["-6.9303801", "-6.8503801", "109.3406311", "109.4206311"]
  }
]

      */
      dispatch({
        type: "set_value_properties",
        payload: {
          key: "location_result_list",
          value: res?.data || [],
        },
      });
    } catch (e) {}
  };
